import { ChallengeAssetsMetadata } from 'src/store/signup-workflow/types';
import { ChallengePlanId } from 'src/pages/types';

export const challengeSupplementIncludedItems = [
  'Full access to the 8 Week Challenge',
  'Supplements Challenge Pack (valued at $85)',
  'Challenge tracker, challenge guide + recipe eBook',
  'Entry into the $15,000 transformation prize pool',
];

export const challengeOnlyIncludedItems = [
  'Full access to the 8 Week Challenge',
  'Challenge tracker, challenge guide + recipe eBook',
  'Entry into the $15,000 transformation prize pool',
];

export const getChallengeIncludedItems = (
  challengeId: string | undefined,
  assetMetadata?: ChallengeAssetsMetadata
) => {
  if (challengeId === ChallengePlanId.ONLY_CHALLENGE) {
    return (
      assetMetadata?.whatsIncludedInChallenge?.challengeOnly ||
      challengeOnlyIncludedItems
    );
  }
  return (
    assetMetadata?.whatsIncludedInChallenge?.supplementBundle ||
    challengeSupplementIncludedItems
  );
};
